// Mock environment configuration for tests

const mockConfig = {
  REACT_APP_API_BASE_URL: 'http://localhost:3000',
  REACT_APP_COGNITO_USER_POOL_ID: 'test-pool-id',
  REACT_APP_COGNITO_CLIENT_ID: 'test-client-id',
  REACT_APP_COGNITO_DOMAIN: 'test.auth.domain',
  REACT_APP_COGNITO_REGION: 'test-region',
  REACT_APP_ENVIRONMENT: 'test',
  REACT_APP_COGNITO_RESOURCE_SERVER_IDENTIFIER: 'test-api'
};

export async function loadEnvConfig() {
  return mockConfig;
}

// Mock import.meta.env
export const env = {
  DEV: true,
  PROD: false,
  TEST: true,
  MODE: 'test',
  BASE_URL: '/',
  VITE_API_BASE_URL: 'http://localhost:3000'
}; 